module.exports = __webpack_public_path__ + "img/pass.9b025db7.png";